import { getTopCategoriesAction } from "@redux/actions";
import clsx from "clsx";
import React, { useEffect } from "react";
import { Card, ListGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styles from "./styles/TopCategories.module.css";

const TopCategories = () => {
  // state

  // variables
  let data = [];

  // logics before hooks

  // hooks
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { topCategories } = useSelector((state) => state.category);

  // logics

  // UI partials

  // effects

  // render

  if (topCategories.data) {
    data = topCategories.data;
  }

  useEffect(() => {
    !topCategories.data && dispatch(getTopCategoriesAction());
  }, []);

  return (
    <Card>
      <Card.Header className={clsx("font-weight-bold", styles.header)}>
        Top Categories
      </Card.Header>
      <ListGroup variant="flush">
        {data.map((item, index) => {
          let rank = "th";
          switch (index) {
            case 0:
              rank = "st";
              break;
            case 1:
              rank = "nd";
              break;
            case 2:
              rank = "rd";
              break;
            default:
              rank = "th";
          }
          return (
            <ListGroup.Item
              action
              key={index}
              onClick={() => navigate(`/explore?CategoryId=${item.id}`)}
            >
              <span className={clsx("mr-2", styles.rank, styles[rank])}>
                {index < 3 ? <i className="bi bi-trophy-fill" /> : index + 1}
                {index >= 3 && <small>{rank}</small>}
              </span>
              {item.name}
            </ListGroup.Item>
          );
        })}
      </ListGroup>
    </Card>
  );
};

/* required: display name */
TopCategories.displayName = "TopCategories";

/* required: props types */
TopCategories.propTypes = {};

/* required: default props */
TopCategories.defaultProps = {};

export { TopCategories };
